import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SystemInputs } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import { KEY_PREFIX } from "./usePaginatedInputs";
const createInput = async ({ input }) => SystemInputs.create(input);
const updateInput = async ({ input, inputId }) => SystemInputs.update(input, inputId);
const deleteInput = async ({ inputId }) => SystemInputs.terminate(inputId);
const useInputMutations = () => {
  const queryClient = useQueryClient();
  const createMutation = useMutation({
    mutationFn: createInput,
    onError: (errorThrown) => {
      UserNotification.error(`Saving input failed with status: ${errorThrown}`, "Could not save input");
    },
    onSuccess: () => {
      UserNotification.success("Input has been successfully created.", "Success!");
      queryClient.invalidateQueries({ queryKey: KEY_PREFIX });
    }
  });
  const updateMutation = useMutation({
    mutationFn: updateInput,
    onError: (errorThrown) => {
      UserNotification.error(`Updating input failed with status: ${errorThrown}`, "Could not update input");
    },
    onSuccess: () => {
      UserNotification.success("Input has been successfully updated.", "Success!");
      queryClient.invalidateQueries({ queryKey: ["inputs"] });
    }
  });
  const deleteMutation = useMutation({
    mutationFn: deleteInput,
    onError: (errorThrown) => {
      UserNotification.error(`Deleting input failed with status: ${errorThrown}`, "Could not delete input");
    },
    onSuccess: () => {
      UserNotification.success("Input has been successfully deleted.", "Success!");
      queryClient.invalidateQueries({ queryKey: KEY_PREFIX });
    }
  });
  return {
    createInput: createMutation.mutateAsync,
    updateInput: updateMutation.mutateAsync,
    deleteInput: deleteMutation.mutateAsync
  };
};
export default useInputMutations;
